
import React, { useCallback } from "react";
import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import { Review, GroupedReview } from "@/types/review";
import { config } from "@/config";
import ReviewMarkers from "./ReviewMarkers";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

interface MapContentProps {
  reviews: Review[];
  center: google.maps.LatLngLiteral;
  mapKey: string;
  groupedReviews?: GroupedReview[];
  setMapInstanceRef: (map: google.maps.Map | null) => void;
}

const MapContent: React.FC<MapContentProps> = ({ 
  reviews, 
  center, 
  mapKey,
  groupedReviews,
  setMapInstanceRef 
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: config.googleMapsApiKey,
  });

  const onMapLoad = useCallback((map: google.maps.Map) => {
    setMapInstanceRef(map);
  }, [setMapInstanceRef]);

  if (loadError) return <div className="w-full h-full flex items-center justify-center">Error loading maps</div>;
  if (!isLoaded) return <div className="w-full h-full flex items-center justify-center">Loading maps...</div>;

  return (
    <GoogleMap
      id={mapKey}
      mapContainerStyle={mapContainerStyle}
      zoom={13}
      center={center}
      options={{
        disableDefaultUI: false,
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
      }}
      onLoad={onMapLoad}
    >
      <ReviewMarkers 
        reviews={reviews} 
        groupedReviews={groupedReviews}
      />
    </GoogleMap>
  );
};

export default MapContent;
